/**
 * Bestek material classification via MMS ArtikelStatus.
 * Status codes starting with "1" (e.g. "122-Use & Long Life") are full
 * replacement parts; everything else is treated as repair material.
 */

const isReplacementMaterialByStatus = (artikelStatus) =>
  String(artikelStatus || "")
    .trim()
    .startsWith("1");

const isReplacementMaterialLine = (line = {}) => {
  if (line.isReplacementPart === true) return true;
  if (line.isReplacementPart === false) return false;
  return isReplacementMaterialByStatus(line.artikelStatus);
};

const partitionMaterialLines = (materials = []) => {
  const repairMaterials = [];
  const replacementMaterials = [];
  for (const mat of materials) {
    if (isReplacementMaterialLine(mat)) {
      replacementMaterials.push(mat);
    } else {
      repairMaterials.push(mat);
    }
  }
  return { repairMaterials, replacementMaterials };
};

const sumMaterialLinesAmount = (materials = [], amountKey = "amount") =>
  materials.reduce((sum, mat) => {
    const n = Number(mat?.[amountKey] ?? mat?.total ?? 0);
    return sum + (Number.isFinite(n) ? n : 0);
  }, 0);

module.exports = {
  isReplacementMaterialByStatus,
  isReplacementMaterialLine,
  partitionMaterialLines,
  sumMaterialLinesAmount,
};
